// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IUserCommunicationConfigurationInfoDto } from './IUserCommunicationConfigurationInfoDto';
import {
    IUserCommunicationConfigurationInfoDtoFromJSON,
    IUserCommunicationConfigurationInfoDtoFromJSONTyped,
    IUserCommunicationConfigurationInfoDtoToJSON,
    IUserCommunicationConfigurationInfoDtoToJSONTyped,
} from './IUserCommunicationConfigurationInfoDto';

/**
 * 
 * @export
 * @interface IPublicEmployeeInfoDto
 */
export interface IPublicEmployeeInfoDto {
    /**
     * 
     * @type {number}
     * @memberof IPublicEmployeeInfoDto
     */
    id?: number | null;
    /**
     * 
     * @type {string}
     * @memberof IPublicEmployeeInfoDto
     */
    custom_field1?: string;
    /**
     * 
     * @type {string}
     * @memberof IPublicEmployeeInfoDto
     */
    custom_field2?: string;
    /**
     * 
     * @type {string}
     * @memberof IPublicEmployeeInfoDto
     */
    custom_field3?: string;
    /**
     * 
     * @type {string}
     * @memberof IPublicEmployeeInfoDto
     */
    custom_field4?: string;
    /**
     * 
     * @type {string}
     * @memberof IPublicEmployeeInfoDto
     */
    custom_field5?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IPublicEmployeeInfoDto
     */
    is_created_by_orphan?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof IPublicEmployeeInfoDto
     */
    mfa_locked_to?: Date;
    /**
     * 
     * @type {string}
     * @memberof IPublicEmployeeInfoDto
     */
    ssn?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IPublicEmployeeInfoDto
     */
    is_fraud_review_required?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof IPublicEmployeeInfoDto
     */
    fraud_review_required_at?: Date;
    /**
     * 
     * @type {number}
     * @memberof IPublicEmployeeInfoDto
     */
    person_id: number;
    /**
     * 
     * @type {number}
     * @memberof IPublicEmployeeInfoDto
     */
    organization_id: number;
    /**
     * 
     * @type {string}
     * @memberof IPublicEmployeeInfoDto
     */
    employer_employee_id: string;
    /**
     * 
     * @type {string}
     * @memberof IPublicEmployeeInfoDto
     */
    partner_employee_id: string;
    /**
     * 
     * @type {string}
     * @memberof IPublicEmployeeInfoDto
     */
    employment_status?: IPublicEmployeeInfoDtoEmploymentStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof IPublicEmployeeInfoDto
     */
    hire_on: Date;
    /**
     * 
     * @type {string}
     * @memberof IPublicEmployeeInfoDto
     */
    organization_path?: string;
    /**
     * 
     * @type {string}
     * @memberof IPublicEmployeeInfoDto
     */
    preferred_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPublicEmployeeInfoDto
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof IPublicEmployeeInfoDto
     */
    last_name: string;
    /**
     * 
     * @type {Date}
     * @memberof IPublicEmployeeInfoDto
     */
    birth_on?: Date;
    /**
     * 
     * @type {IUserCommunicationConfigurationInfoDto}
     * @memberof IPublicEmployeeInfoDto
     */
    user_communication_configuration?: IUserCommunicationConfigurationInfoDto;
    /**
     * 
     * @type {string}
     * @memberof IPublicEmployeeInfoDto
     */
    claim_autopay_type?: IPublicEmployeeInfoDtoClaimAutopayTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IPublicEmployeeInfoDto
     */
    default_claim_payee_type?: IPublicEmployeeInfoDtoDefaultClaimPayeeTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof IPublicEmployeeInfoDto
     */
    termination_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof IPublicEmployeeInfoDto
     */
    payroll_group_code?: string;
    /**
     * 
     * @type {Date}
     * @memberof IPublicEmployeeInfoDto
     */
    valid_from?: Date;
    /**
     * 
     * @type {string}
     * @memberof IPublicEmployeeInfoDto
     */
    id_source_type?: IPublicEmployeeInfoDtoIdSourceTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum IPublicEmployeeInfoDtoEmploymentStatusEnum {
    A = 'A',
    T = 'T',
    L = 'L',
    R = 'R',
    F = 'F',
    C = 'C'
}
/**
* @export
* @enum {string}
*/
export enum IPublicEmployeeInfoDtoClaimAutopayTypeEnum {
    AUTO = 'AUTO',
    CLICK = 'CLICK'
}
/**
* @export
* @enum {string}
*/
export enum IPublicEmployeeInfoDtoDefaultClaimPayeeTypeEnum {
    PARTICIPANT = 'PARTICIPANT',
    PROVIDER = 'PROVIDER',
    EMPLOYEE_CHOICE = 'EMPLOYEE_CHOICE'
}
/**
* @export
* @enum {string}
*/
export enum IPublicEmployeeInfoDtoIdSourceTypeEnum {
    SSN = 'SSN',
    EMPLOYER_EMPLOYEE_ID = 'EMPLOYER_EMPLOYEE_ID',
    PARTNER_EMPLOYEE_ID = 'PARTNER_EMPLOYEE_ID'
}


/**
 * Check if a given object implements the IPublicEmployeeInfoDto interface.
 */
export function instanceOfIPublicEmployeeInfoDto(value: object): value is IPublicEmployeeInfoDto {
    if (!('person_id' in value) || value['person_id'] === undefined) return false;
    if (!('organization_id' in value) || value['organization_id'] === undefined) return false;
    if (!('employer_employee_id' in value) || value['employer_employee_id'] === undefined) return false;
    if (!('partner_employee_id' in value) || value['partner_employee_id'] === undefined) return false;
    if (!('hire_on' in value) || value['hire_on'] === undefined) return false;
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    return true;
}

export function IPublicEmployeeInfoDtoFromJSON(json: any): IPublicEmployeeInfoDto {
    return IPublicEmployeeInfoDtoFromJSONTyped(json, false);
}

export function IPublicEmployeeInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPublicEmployeeInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'custom_field1': json['customField1'] == null ? undefined : json['customField1'],
        'custom_field2': json['customField2'] == null ? undefined : json['customField2'],
        'custom_field3': json['customField3'] == null ? undefined : json['customField3'],
        'custom_field4': json['customField4'] == null ? undefined : json['customField4'],
        'custom_field5': json['customField5'] == null ? undefined : json['customField5'],
        'is_created_by_orphan': json['isCreatedByOrphan'] == null ? undefined : json['isCreatedByOrphan'],
        'mfa_locked_to': json['mfaLockedTo'] == null ? undefined : (new Date(json['mfaLockedTo'])),
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'is_fraud_review_required': json['isFraudReviewRequired'] == null ? undefined : json['isFraudReviewRequired'],
        'fraud_review_required_at': json['fraudReviewRequiredAt'] == null ? undefined : (new Date(json['fraudReviewRequiredAt'])),
        'person_id': json['person_id'],
        'organization_id': json['organization_id'],
        'employer_employee_id': json['employer_employee_id'],
        'partner_employee_id': json['partner_employee_id'],
        'employment_status': json['employment_status'] == null ? undefined : json['employment_status'],
        'hire_on': (new Date(json['hire_on'])),
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'preferred_name': json['preferred_name'] == null ? undefined : json['preferred_name'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'birth_on': json['birth_on'] == null ? undefined : (new Date(json['birth_on'])),
        'user_communication_configuration': json['user_communication_configuration'] == null ? undefined : IUserCommunicationConfigurationInfoDtoFromJSON(json['user_communication_configuration']),
        'claim_autopay_type': json['claim_autopay_type'] == null ? undefined : json['claim_autopay_type'],
        'default_claim_payee_type': json['default_claim_payee_type'] == null ? undefined : json['default_claim_payee_type'],
        'termination_date': json['termination_date'] == null ? undefined : (new Date(json['termination_date'])),
        'payroll_group_code': json['payroll_group_code'] == null ? undefined : json['payroll_group_code'],
        'valid_from': json['valid_from'] == null ? undefined : (new Date(json['valid_from'])),
        'id_source_type': json['id_source_type'] == null ? undefined : json['id_source_type'],
    };
}

export function IPublicEmployeeInfoDtoToJSON(json: any): IPublicEmployeeInfoDto {
    return IPublicEmployeeInfoDtoToJSONTyped(json, false);
}

export function IPublicEmployeeInfoDtoToJSONTyped(value?: IPublicEmployeeInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'customField1': value['custom_field1'],
        'customField2': value['custom_field2'],
        'customField3': value['custom_field3'],
        'customField4': value['custom_field4'],
        'customField5': value['custom_field5'],
        'isCreatedByOrphan': value['is_created_by_orphan'],
        'mfaLockedTo': value['mfa_locked_to'] == null ? undefined : ((value['mfa_locked_to']).toISOString()),
        'ssn': value['ssn'],
        'isFraudReviewRequired': value['is_fraud_review_required'],
        'fraudReviewRequiredAt': value['fraud_review_required_at'] == null ? undefined : ((value['fraud_review_required_at']).toISOString()),
        'person_id': value['person_id'],
        'organization_id': value['organization_id'],
        'employer_employee_id': value['employer_employee_id'],
        'partner_employee_id': value['partner_employee_id'],
        'employment_status': value['employment_status'],
        'hire_on': ((value['hire_on']).toISOString()),
        'organization_path': value['organization_path'],
        'preferred_name': value['preferred_name'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'birth_on': value['birth_on'] == null ? undefined : ((value['birth_on']).toISOString().substring(0,10)),
        'user_communication_configuration': IUserCommunicationConfigurationInfoDtoToJSON(value['user_communication_configuration']),
        'claim_autopay_type': value['claim_autopay_type'],
        'default_claim_payee_type': value['default_claim_payee_type'],
        'termination_date': value['termination_date'] == null ? undefined : ((value['termination_date']).toISOString()),
        'payroll_group_code': value['payroll_group_code'],
        'valid_from': value['valid_from'] == null ? undefined : ((value['valid_from']).toISOString()),
        'id_source_type': value['id_source_type'],
    };
}

